var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-start":""}},[_c('v-flex',{staticClass:"mx-auto",staticStyle:{"width":"100%"}},[_c('vandarTable',{attrs:{"update":_vm.updateTable},on:{"updateSettelment":function($event){return _vm.allupdates()},"doneUpdateTable":function($event){return _vm.done_update_table()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }